import React from 'react';

const FooterIcon = ({href, src, alt}) => (
  <a href={href} target="__blank">
    <img src={src} alt={alt} />
  </a>
);

export default FooterIcon;
